import { ListItemIcon, ListItemText, MenuItem, styled, Typography } from '@ethings/ui-toolkit';
import React, { memo, type JSX } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { COUNTRIES } from './constants';
import { FlagMenuItemProps } from './types';

const StyledListItemIcon = styled(ListItemIcon)({
  marginRight: '10px',
});

const StyledListItemText = styled(ListItemText)({
  marginRight: '10px',
});

const FlagMenuItem = (props: FlagMenuItemProps): JSX.Element => {
  const { isoCode, onSelectCountry, displayNames, ...menuItemProps } = props;

  const handleClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>): void => {
    event.preventDefault();
    onSelectCountry(isoCode);
  };

  const countryName = displayNames.of(isoCode);

  return (
    <MenuItem
      {...menuItemProps}
      onClick={handleClick}
      role="option"
      data-testid={`phone-input-country-option-${isoCode.toString()}`}
      className="PhoneInput-MenuItem"
    >
      <StyledListItemIcon>
        <ReactCountryFlag countryCode={isoCode} svg />
      </StyledListItemIcon>
      <StyledListItemText>
        {countryName}
      </StyledListItemText>
      <Typography variant="body2" color="text.secondary">
        +{COUNTRIES[isoCode]?.[0]}
      </Typography>
    </MenuItem>
  );
};

export default memo(FlagMenuItem);
